<p-table [value]="this.supervisorService.selectedThread ?? []">
  <ng-template
    pTemplate="body"
    let-historyItem
    let-i="rowIndex"
  >
    @if (i === 0) {
    @for (socketEvent of this.supervisorService.getPreFirstMessageSocketEvents(); track socketEvent) {
    <tr
      class="chat-row socketevent-chat-row"
      style="vertical-align: top;"
    >
      <td
        style="font-family: monospace; white-space: nowrap; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        {{socketEvent.created | date: 'dd/MM/yyyy HH:mm:ss'}}
      </td>
      <td></td>
      <td
        style="font-family: monospace;"
        width="100%"
      >
        @if (socketEvent.type === 'disconnect') {
        <p i18n="@@socketEvent-disconnected">Verbindung getrennt</p>
        }
        @if (socketEvent.type === 'connect') {
        <p i18n="@@connected">Verbunden</p>
        }
      </td>
    </tr>
    }
    }
    <tr
      class="chat-row"
      style="vertical-align: top;"
    >
      <td
        style="font-family: monospace; white-space: nowrap; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        {{historyItem.created | date: 'dd/MM/yyyy HH:mm:ss'}}

        @if (historyItem.role === 'assistant' ) {
        <br>
        @let prevHistoryItem = this.getHistoryItemByIndex(i-1);
        @if (prevHistoryItem){
        {{this.supervisorService.getTimeDifferenceMS(historyItem)}} ms
        }
        }
      </td>
      <td
        style="font-family: monospace; text-align: right; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        <b>{{historyItem.role}}:</b>
      </td>
      <td
        style="font-family: monospace;"
        width="100%"
      >
        @if (historyItem.role === 'botcard') {
        @let cardText = this.getTextFromMessageContent(historyItem.content);
        <code
          class="text-truncate d-block"
          style="width: 200px; cursor: pointer"
          [pTooltip]="cardText"
          tooltipPosition="right"
          [showDelay]="300"
          (click)="this.openCodeDialog(cardText)"
        >
          {{cardText}}
        </code>
        }
        @if (historyItem.role !== 'botcard') {
        @for (hr of this.supervisorService.getHelpRequestsFrom(historyItem); track hr) {
        <app-supervisor-notification [helpRequest]="hr"></app-supervisor-notification>
        }
        <i>{{this.getTextFromMessageContent(historyItem.content)}}</i>
        }
      </td>
    </tr>
    @for (adminMessage of this.supervisorService.getAdminMessages(i); track adminMessage) {
    <tr
      class="chat-row admin-chat-row"
      style="vertical-align: top;"
    >
      <td
        style="font-family: monospace; white-space: nowrap; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        {{adminMessage.created | date: 'dd/MM/yyyy HH:mm'}}
      </td>
      <td
        style="font-family: monospace; text-align: right; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        <b i18n="@@supervisor-admin-label">admin:</b>
      </td>
      <td
        style="font-family: monospace;"
        width="100%"
      >
        <i>{{adminMessage.content}}</i>
      </td>
    </tr>
    @if (adminMessage.userAnswer !== '') {
    <tr
      class="chat-row admin-answer-chat-row"
      style="vertical-align: top;"
    >
      <td></td>
      <td
        style="font-family: monospace; text-align: right; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        <b i18n="@@supervisor-user-answer-label">answer:</b>
      </td>
      <td>{{adminMessage.userAnswer}}</td>
    </tr>
    }
    }
    @for (socketEvent of this.supervisorService.getSocketEvents(i); track socketEvent) {
    <tr
      class="chat-row socketevent-chat-row"
      style="vertical-align: top;"
    >
      <td
        style="font-family: monospace; white-space: nowrap; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
        {{socketEvent.created | date: 'dd/MM/yyyy HH:mm:ss'}}
      </td>
      <td
        style="font-family: monospace; text-align: right; padding-left: 0.5rem; padding-right: 0.5rem; font-size: 0.875rem;"
      >
      </td>
      <td
        style="font-family: monospace;"
        width="100%"
      >
        @if (socketEvent.type === 'disconnect') {
        <p i18n="@@socketEvent-disconnected">Verbindung getrennt</p>
        }
        @if (socketEvent.type === 'connect') {
        <p i18n="@@connected">Verbunden</p>
        }
      </td>
    </tr>
    }
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="this.codeDialogVisible"
  [modal]="true"
  [closable]="true"
  [style]="{width: '60vw'}"
  i18n-header="@@botcard-dialog-header"
  header="Bot Card"
>
  <pre style="white-space: pre-wrap; word-break: break-all; font-size: 0.85rem">{{this.codeDialogContent}}</pre>
</p-dialog>